import "./App.css";
import './i18n';
import { Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './contexts/ThemeContext';
import GoogleAnalytics from "./components/GoogleAnalytics";
import WhatsAppButton from "./components/WhatsAppButton";
import { initLinkTracking } from "./utils/analytics";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import RDV from "./pages/RDV";
import FAQ from "./pages/FAQ";
import Galerie from "./pages/Galerie";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminGallery from "./pages/AdminGallery";
import AdminGroups from "./pages/AdminGroups";
import AdminCRM from "./pages/AdminCRM";
import AdminMongoDB from "./pages/AdminMongoDB";
import DevisAnalytics from "./pages/DevisAnalytics";
import About from "./pages/About";
import HowItWorks from "./pages/HowItWorks";
import Projets from "./pages/Projets";
import Confidentialite from "./pages/Confidentialite";
import Devis from "./pages/Devis";
import Tarifs from "./pages/Tarifs";
import Services from "./pages/Services";
import LocalLanding from "./pages/LocalLanding";
import ZonesIntervention from "./pages/ZonesIntervention";
import Footer from "./components/Footer";

function App() {
  useEffect(() => { initLinkTracking(); }, []);
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <HelmetProvider>
        <ThemeProvider>
          <div className="App">
            <BrowserRouter>
              <GoogleAnalytics />
              <WhatsAppButton />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/rdv" element={<RDV />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/galerie" element={<Galerie />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/admin/gallery" element={<AdminGallery />} />
                <Route path="/admin/groups" element={<AdminGroups />} />
                <Route path="/admin/crm" element={<AdminCRM />} />
                <Route path="/admin/mongodb" element={<AdminMongoDB />} />
                <Route path="/admin/devis-analytics" element={<DevisAnalytics />} />
                <Route path="/about" element={<About />} />
                <Route path="/comment-ca-marche" element={<HowItWorks />} />
                <Route path="/projets" element={<Projets />} />
                <Route path="/confidentialite" element={<Confidentialite />} />
                <Route path="/devis" element={<Devis />} />
                <Route path="/tarifs" element={<Tarifs />} />
                <Route path="/services" element={<Services />} />
                <Route path="/zones-intervention" element={<ZonesIntervention />} />
                <Route path="/:slug" element={<LocalLanding />} />
              </Routes>
              <Footer />
            </BrowserRouter>
          </div>
        </ThemeProvider>
      </HelmetProvider>
    </Suspense>
  );
}

export default App;
